import React from "react";
import type { FC } from "react";

import { Picture } from "../../../../Picture";
import { createDisplayNameForContentElement } from "../../utils/getDisplayName";
import { createTestIdForContentElement } from "../../utils/getTestId";

import type { OmitOfUnion } from "../../../../../types/react";
import type { PictureProps } from "../../../../Picture";

const CONTENT_PICTURE_TEST_ID = createTestIdForContentElement("picture");

type ContentPictureProps = OmitOfUnion<PictureProps, "size">;

export const ContentPicture: FC<ContentPictureProps> = (props) => {
    return (
        <Picture
            {...(props as PictureProps)}
            data-tsid={CONTENT_PICTURE_TEST_ID}
        />
    );
};

ContentPicture.displayName = createDisplayNameForContentElement("Picture");

export default ContentPicture;
